import React, { PropsWithChildren, ReactElement } from "react";
import * as styles from "./CruiseDrawerItineraryHilights.module.scss";
import { Icon, IconName } from "@silversea-ssc/ui-components-react";

export const CruiseDrawerItineraryHilights: React.FC<PropsWithChildren> = ({
  children
}) => <dl className={styles.list}>{children}</dl>;

type CruiseDrawerItineraryHilightProps = {
  iconName: IconName;
  title: ReactElement | string;
};

export const CruiseDrawerItineraryHilight: React.FC<
  PropsWithChildren<CruiseDrawerItineraryHilightProps>
> = ({ iconName, title, children }) => {
  return (
    <>
      <dt>
        <Icon
          name={iconName}
          padding="inline-right"
          size="1.5x"
          className={styles.icon}
        />
        {title}
      </dt>
      {children && <dd>{children}</dd>}
    </>
  );
};
